/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { getString } from '../../utils/l10n';
import { FortifyStatus } from '../fortify-status';
import { FortifyButton } from '../fortify-button';

export interface FortifyNotSupportedProps {
  onCancel: (event: MouseEvent) => void;
}

export const FortifyNotSupported: FunctionalComponent<FortifyNotSupportedProps> = (props) => {
  const { onCancel } = props;

  return (
    <FortifyStatus
      title={getString('support.title')}
      description={getString('support.description')}
    >
      <FortifyButton
        onClick={onCancel}
      >
        {getString('actions.cancel')}
      </FortifyButton>
    </FortifyStatus>
  );
};
